import React from "react";

import { GOVERNANCE_LIFECYCLE_STATUSES } from "../../models";

const STAGES = Object.values(GOVERNANCE_LIFECYCLE_STATUSES);

const LABELS = {
  DRAFT: "Draft",
  UNDER_REVIEW: "Under Review",
  BOARD_DISCUSSION: "Board Discussion",
  DECISION_PENDING: "Decision Pending",
  RESOLVED: "Resolved",
  MONITORING: "Monitoring",
};

export default function GovernanceLifecycle({ status }) {
  const currentIndex = STAGES.indexOf(status);
  const currentLabel = currentIndex >= 0 ? LABELS[status] : "Not available";

  return (
    <section aria-labelledby="governance-lifecycle-heading" className="rounded-lg border border-slate-200 bg-slate-50 p-4">
      <p id="governance-lifecycle-heading" className="text-xs font-semibold uppercase tracking-wider text-slate-500">
        Governance Lifecycle
      </p>
      <div className="mt-2">
        <p className="text-xs text-slate-500">Current Stage</p>
        <p className="text-lg font-semibold text-slate-950">{currentLabel}</p>
      </div>

      <ol aria-label="Governance lifecycle stages" className="mt-4 grid gap-2 sm:grid-cols-3 xl:grid-cols-6">
        {STAGES.map((stage, index) => {
          const reached = currentIndex >= 0 && index <= currentIndex;
          const current = index === currentIndex;

          return (
            <li key={stage} aria-current={current ? "step" : undefined} className="flex items-center gap-2 text-xs text-slate-600">
              <span aria-hidden="true" className={`h-2.5 w-2.5 shrink-0 rounded-full border ${reached ? "border-slate-900 bg-slate-900" : "border-slate-400 bg-white"}`} />
              <span className={current ? "font-semibold text-slate-950" : ""}>{LABELS[stage]}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
